import { css } from '@emotion/react';

import { theme } from '../../theme';

export const checkboxLabel = (onlyText: boolean) => css`
  display: flex;
  align-items: ${onlyText ? 'center' : 'start'};
  font-size: 16px;
  cursor: pointer;
`;

export const checkbox = css`
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 0.5rem;
`;

export const description = css`
  flex: 1;
  text-align: right;
  font-size: 0.875rem;
  color: ${theme.colors.gray[300]};
`;

export const error = css`
  font-size: 0.8rem;
  color: ${theme.colors.danger};
`;

export const inputWrapper = css`
  position: relative;
`;

export const inputIconContainer = css`
  position: absolute;
  left: ${theme.spacing.md};
  top: 1.25rem;
  color: var(--color-blue-2);

  & svg {
    width: ${theme.spacing.lg};
    height: ${theme.spacing.lg};
  }
`;

export const fieldInfo = css`
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  padding-top: 0.25rem;
`;

export const fieldStyles = css`
  position: relative;
  height: 64px;
`;

export const inputStyles = (hasError: boolean, isFocused: boolean, withIcon?: boolean) => css`
  width: 100%;
  height: 100%;
  background: white;
  border: 1px solid ${hasError && !isFocused ? theme.colors.danger : theme.colors.gray[2]};
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 20px 10px 0 16px;
  padding-left: ${withIcon ? theme.spacing.xxxl : theme.spacing.md};
  line-height: 24px;

  transition: outline background-color 0.2s;

  &::placeholder {
    color: transparent;
  }

  &:focus,
  &:hover {
    background-color: #e8e8e8;
  }

  &:active,
  &:focus {
    outline: 2px solid ${theme.colors.primary};
  }
`;

export const fieldLabel = (isFocused: boolean, withIcon?: boolean) => css`
  position: absolute;
  display: block;
  transition: 0.2s;
  left: ${withIcon ? theme.spacing.xxxl : theme.spacing.md};
  right: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  top: ${isFocused ? '10px' : '21px'};
  font-size: ${isFocused ? '13px' : '16px'};
  color: ${isFocused ? '#3f3d3a' : theme.colors.gray20};

  > sup {
    position: absolute;
    top: 0px;
    font-size: 80%;
  }
`;

export const selectArrow = css`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;

  svg {
    color: ${theme.colors.text};
  }
`;

export const phoneWrapper = css`
  width: auto;
  display: flex;
  flex-direction: column;
`;
export const phoneContainer = css`
  display: flex;
`;

export const phoneCountry = (hasError: boolean) => css`
  border: 1px solid ${hasError ? theme.colors.danger : theme.colors.gray[2]};
  width: 120px;
  border-right: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`;

export const phoneNumberWrapper = css`
  flex: 1;
  width: 100%;
`;

export const phoneNumber = (hasError: boolean) => css`
  border: 1px solid ${hasError ? theme.colors.danger : theme.colors.gray[2]};
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
`;
